import { NotificationService } from 'src/app/shared/services/notification.service';
import {
  inject,
  Component,
  OnInit,
  ChangeDetectorRef,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { UploaderConfig } from '../../shared/ecpl-document-explorer/uploader-config';
import { treeNodeKey } from '../../shared/ecpl-document-tree/tree-node-key';
import { ArchiveServices } from './archive.services';
import { BaseServices } from '../kuba.services';
import { ManualService } from '../manuals/services/manual.services';
import { Subscription } from 'rxjs';
import { TreeData } from '../common/models/tree-data.model';

class ArchiveDocumentModel {
  Id: number;
  Title: string;
  OriginalFileName: string;
  Path: string;
  MimeType: string;
  Size: number;
  DocumentTypeId: number;
  FeatureFolderId: number;
  FeatureId: number;
  FeatureKey: number;
  Status: string;
  CreatedBy: number;
  ModifiedBy: number;
}

@Component({
  templateUrl: 'archive.component.html',
  standalone: false
})
export class ArchiveComponent implements OnInit {
  private readonly notifications = inject(NotificationService);

  @ViewChild('ecplDocumentTree', { static: false }) ecplDocumentTree: any;
  @ViewChild('accessDeniedModal') accessDeniedModal: TemplateRef<any>;
  modalRef: BsModalRef;
  bsConfig = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };
  applicationId: number;
  featureId: number;
  featureName = '';
  featureKeyName: string;
  featureKey: number;
  triggerUploader = false;
  showSavingLoader = false;
  treeNode: any;
  editMode = false;
  treeActiveNode: any;
  isUpdatingTree = false;

  // Document Explorer Configs
  additionalData: any;
  upConfig: UploaderConfig;
  uploadedFiles: any;
  UploadableFile: any;

  featuredocumentId: number;
  additionalFeatures: any;
  pageTitle: string;
  locale: string;
  downloadAll = false;
  allFiles: any[];
  isShowAllFile = false;
  isHideShowAllButton = false;
  archiveUserRights: any;
  isShowButton: boolean;
  Userrights: any;
  administrateUserRights: any;
  administrateachive2: any;
  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private modalService: BsModalService,
    private archiveServices: ArchiveServices,
    private manualService: ManualService
  ) {
    this.Userrights = BaseServices.UserRole;
    this.featureKey = route.snapshot.parent!.params['id'];
    this.featureKeyName = this.route.snapshot.params['manualname'];
    this.applicationId = BaseServices.ApplicationId;
    this.upConfig = {
      title: 'ALL_FILES',
      viewSwitch: false,
      editMode: this.editMode,
      windowedHeight: true,
      uploaderUri: environment.BASE_URL + '/file/upload/business/manual',
      showDownloadAll: this.downloadAll,
      addtionalData: null,
      showDeleteAllButton: true,
      isArchive: true
    };
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule')!);
    this.featureName = workingModule.Title;
    this.featureId = workingModule.id;
  }

  // Emitter for selected folder from Document Explorer
  setActiveNodeIntree(event: any) {
    this.treeActiveNode = event;
  }

  // Toggle Edit Mode
  toggleEditMode() {
    this.editMode = !this.editMode;
    // Derive the explorer's mode from editMode instead of toggling it
    // separately - two independent flags can drift out of sync.
    this.upConfig.editMode = this.editMode;
  }

  // Events form Tree
  catchTreeEvent(event: any): void {
    this.triggerUploader = false;
    switch (event.eventName) {
      case 'CheckBoxStatus':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices
            .updateManualCheckboxstatus(event.node.data)
            .subscribe(
              response => {
                this.refreshTreeNode();
              },
              error => {
                console.log('Checkbox status not update : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Checkbox status updated')
            )
        );
        break;
      case 'AddNewRootFolder':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices.createRootFolder(event, true).subscribe(
            response => {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.refreshTreeNode();
            },
            error => {
              console.log('Manual Create folder Error : ', error);
              this.isUpdatingTree = false;
            },
            () =>
              console.log(
                'Manual Create folder Complete'
                // this.treeActiveNode.data
              )
          )
        );
        break;
      case 'AddNewSiblingFolder':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices.createManualFolder(event, false).subscribe(
            response => {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.refreshTreeNode();
            },
            error => {
              console.log('Manual Create folder Error : ', error);
              this.isUpdatingTree = false;
            },
            () => console.log('Manual Create sibling folder Complete')
          )
        );
        break;
      case 'AddNewFolder':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices.createManualFolder(event, false).subscribe(
            response => {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.refreshTreeNode();
            },
            error => {
              console.log('Manual Create folder Error : ', error);
              this.isUpdatingTree = false;
            },
            () =>
              console.log(
                'Manual Create folder Complete'
                // this.treeActiveNode.data
              )
          )
        );
        break;

      case 'RenameFolder':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices.renameManualFolder(event).subscribe(
            response => {
              this.refreshTreeNode();
            },
            error => {
              console.log('Manual Create folder Error : ', error);
              this.isUpdatingTree = false;
            },
            () => console.log('Manual Create folder Complete')
          )
        );
        break;
      case 'DeleteSelectedDocuments':
        const nodeIds = this.extractNodeIds(event.item.data);
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices.deleteMultipleDocument(nodeIds).subscribe(
            response => {
              this.notifications.success('UI_NOTIFICATIONS.DELETED');
              this.refreshTreeNode();
            },
            error => {
              console.log('Manual delete folder Error : ', error);
              this.isUpdatingTree = false;
            },
            () => console.log('Manual delete folder Complete')
          )
        );
        break;
      case 'DeleteArchiveSelectedDocuments':
        const checklistIds = this.extractNodeIds(event.item.data);
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices.deleteArchiveCheckList(checklistIds).subscribe(
            response => {
              this.notifications.success('UI_NOTIFICATIONS.DELETED');
              this.refreshTreeNode();
            },
            error => {
              console.log('Manual delete folder Error : ', error);
              this.isUpdatingTree = false;
            },
            () => console.log('Manual delete folder Complete')
          )
        );
        break;
      case 'DeleteDefaultFile':
        this.isUpdatingTree = true;
        if (event.item.data.documentType === 'archiveundercompletion') {
          this.subscriptions.push(
            this.archiveServices
              .deleteArchiveDocument(event.item.data.nodeId)
              .subscribe(
                response => {
                  this.notifications.success('UI_NOTIFICATIONS.DELETED');
                  this.refreshTreeNode();
                },
                error => {
                  console.log('Manual delete folder Error : ', error);
                  this.isUpdatingTree = false;
                },
                () => console.log('Manual delete folder Complete')
              )
          );
        } else if (event.item.data.documentType === 'fsundercompletion') {
          this.subscriptions.push(
            this.archiveServices
              .deleteFoodSafety(event.item.data.nodeId)
              .subscribe(
                response => {
                  this.notifications.success('UI_NOTIFICATIONS.DELETED');
                  this.refreshTreeNode();
                },
                error => {
                  console.log('Manual delete folder Error : ', error);
                  this.isUpdatingTree = false;
                },
                () => console.log('Manual delete folder Complete')
              )
          );
        }

        break;
      case 'DeleteFolder':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices
            .deleteManualFolder(event.item.data.nodeId)
            .subscribe(
              response => {
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
                this.refreshTreeNode();
              },
              error => {
                console.log('Manual delete folder Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual delete folder Complete')
            )
        );

        break;

      case 'AddFiles':
        this.configureExplorerForNode(event.item);
        this.triggerUploader = true;
        break;
      case 'EditFile':
        // TODO:
        break;
      case 'RenameFile':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices.renameDocument(event).subscribe(
            response => {
              this.refreshTreeNode();
            },
            error => {
              console.log('Rename article error : ', error);
              this.isUpdatingTree = false;
            },
            () => console.log('Rename article Complete')
          )
        );
        break;
      case 'DeleteFile':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices.deleteDocument(event.item.data.nodeId).subscribe(
            response => {
              this.notifications.success('UI_NOTIFICATIONS.DELETED');
              this.refreshTreeNode();
            },
            error => {
              console.log('Manual checklist delete Error : ', error);
              this.isUpdatingTree = false;
            },
            () => console.log('Manual checklist delete Complete')
          )
        );
        break;
      case 'NewArticle':
        // TODO:
        break;
      case 'SaveArticle':
        // TODO:
        break;
      case 'RenameArticle':
        break;
      case 'DeleteArticle':
        break;

      case 'AddChecklist':
        // TODO:
        break;
      case 'EditChecklist':
        // TODO:
        break;
      case 'RenameChecklist':
        break;
      case 'DeleteChecklist':
        break;
      case 'CopyEditVersionDocument':
        this.subscriptions.push(
          this.manualService.createEditCopyofDocument(event).subscribe(
            (response: any) => {
              let docPathDto = {
                Id: event.item.id,
                Path: response.path,
                ModifiedBy: BaseServices.UserId
              };
            },
            error => console.error('Document version  Error : ', error),
            () => console.log('Document version  Complete')
          )
        );
        break;
      case 'moveNode':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices.moveNode(event).subscribe(
            response => {
              if (response) {
                this.refreshTreeNode();
              }
            },
            (error: any) => {
              console.log('Manual movenoxde  Error : ', error);
              this.isUpdatingTree = false;
            },
            () => console.log('Manual movenode  Complete')
          )
        );
        break;
      case 'activate':
        // Check if this is an "under completion" item that needs navigation
        if (
          event.node.data.type !== 'folder' &&
          (event.node.data.documentType === 'archiveundercompletion' ||
            event.node.data.documentType === 'fsundercompletion')
        ) {
          // Navigate to the checklist completion page
          if (event.node.data.documentType === 'archiveundercompletion') {
            if (
              this.Userrights === 'User' &&
              event.node.data.responsibleId &&
              +event.node.data.responsibleId !== +BaseServices.UserId
            ) {
              this.modalRef = this.modalService.show(
                this.accessDeniedModal,
                this.bsConfig
              );
              return;
            }
            this.router.navigate(
              [
                '../../complete-checklist/incomplete/' + event.node.data.nodeId,
                'activity',
                0,
                0
              ],
              { relativeTo: this.route }
            );
          } else if (event.node.data.documentType === 'fsundercompletion') {
            this.router.navigate(
              [
                '../../fs-complete-checklist/incomplete/' +
                  event.node.data.nodeId
              ],
              { relativeTo: this.route }
            );
          }
          return; // Exit early - don't set up document explorer
        }

        this.configureExplorerForNode(event.node);
        this.cdr.detectChanges();
        // Re-apply translations to tree node filenames using already-loaded
        // translations. Use synchronous instant lookup to avoid network calls.
        this.applyTranslationsToTree(this.treeNode);
        // Also update the PrimeNG nodes that the tree renders so labels update
        if (this.ecplDocumentTree && this.ecplDocumentTree.primeNodes) {
          this.applyTranslationsToPrimeNodes(this.ecplDocumentTree.primeNodes);
          try {
            this.ecplDocumentTree.cdr.detectChanges();
          } catch (e) {
            // ignore if tree's cdr isn't available
          }
        }
        break;
      case 'initialized':
        console.log('initialized ');
        break;
      case 'updateData':
        break;
      case 'loadNodeChildren':
        break;
      case 'contextMenu':
        // Context menu event - do nothing here, let the context menu handle it
        break;
      default:
        // Other events - no special handling needed for archive
        break;
    }
  }

  /**
   * Opens/continues an "under completion" checklist from the file window.
   * Mirrors the tree-navigation access check: a normal user may only open a
   * checklist they are responsible for, otherwise an access-denied modal is
   * shown. #5641
   * @param file The file-window item (TreeViewDisplayDto)
   */
  openArchiveChecklist(file: any) {
    if (!file || file.documentType !== 'archiveundercompletion') {
      return;
    }
    if (
      this.Userrights === 'User' &&
      file.responsibleId &&
      +file.responsibleId !== +BaseServices.UserId
    ) {
      this.modalRef = this.modalService.show(
        this.accessDeniedModal,
        this.bsConfig
      );
      return;
    }
    this.router.navigate(
      [
        '../../complete-checklist/incomplete/' + file.nodeId,
        'activity',
        this.featureId,
        0
      ],
      { relativeTo: this.route }
    );
  }

  // emitter for save from Document Explorer
  catchExplorerEvent(event: any) {
    let fileExtension = '';
    if (event.mimetype) {
      const parts = event.mimetype.split('/');
      if (parts.length > 1) {
        fileExtension = parts[1];
        event.mimetype = fileExtension;
      }
    }
    switch (event.eventName) {
      case 'AddNewFolder':
        if (!event.parent && this.treeActiveNode) {
          event.parent = this.treeActiveNode.data;
        }
        this.catchTreeEvent(event);
        break;
      case 'DeleteFolder':
      case 'DeleteArticle':
      case 'DeleteChecklist':
      case 'DeleteFile':
      case 'DeleteDefaultFile':
      case 'DeleteSelectedDocuments':
      case 'DeleteArchiveSelectedDocuments':
        this.catchTreeEvent(event);
        break;
      case 'SaveArticle':
        event.activeNodeId = this.treeActiveNode.data.nodeId;
        this.catchTreeEvent(event);
        break;
      case 'NewArticle':
        event.activeNodeId = this.treeActiveNode.data.nodeId;
        this.catchTreeEvent(event);
        break;
      case 'CopyEditVersionDocument':
        event.activeNodeId = this.treeActiveNode.data.nodeId;
        this.catchTreeEvent(event);
        break;
      case 'ShowOfficeFileSaveloader':
        if (parseInt(sessionStorage.getItem('isDocumentChanged')!, null!)) {
          this.showSavingLoader = true;
          this.isUpdatingTree = true;
          this.archiveServices
            .UpdateDocument(event.item.id, BaseServices.UserId)
            .subscribe(response => {
              if (response) {
              }
            });
          setTimeout(() => {
            this.refreshTreeNode();
            this.showSavingLoader = false;
          }, 15000);
          sessionStorage.setItem('isDocumentChanged', '0');
        }
        break;
      default:
        let uploadedFile = Object.assign(
          {},
          event,
          this.upConfig.addtionalData
        );
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices.addArchiveDocument(uploadedFile).subscribe(
            (result: any) => {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.refreshTreeNode();
            },
            (error: any) => {
              console.error('Archive document service error:', error);
              this.isUpdatingTree = false;
            },
            () => {
              console.log('Adding archive document service complete.');
            }
          )
        );
        break;
    }
  }

  refreshTreeNode() {
    this.subscriptions.push(
      this.archiveServices.getArchiveTree(BaseServices.BusinessId).subscribe(
        (result: any) => {
          // Apply business name transformation to fresh data from server
          this.applyBusinessNameToTree(result);
          
          if (
            this.ecplDocumentTree &&
            this.ecplDocumentTree.primeNodes &&
            this.ecplDocumentTree.primeNodes.length > 0
          ) {
            this.mergeTreeData(this.ecplDocumentTree.primeNodes, result);
            this.ecplDocumentTree.skipRebuildOnChange = true;
            this.treeNode = result;
            this.ecplDocumentTree.cdr.detectChanges();
          } else {
            if (this.ecplDocumentTree) {
              this.treeNode = result;
              this.ecplDocumentTree.ecplTreeData = result;
              this.ecplDocumentTree.buildPrimeNodes();
              this.ecplDocumentTree.cdr.detectChanges();
            }
          }
          // Apply translations to folder names after the view updates
          // Use synchronous instant lookup so we don't trigger any
          // translation loading network calls.
          this.applyTranslationsToTree(this.treeNode);
          // Ensure PrimeNG rendered nodes are updated too
          if (this.ecplDocumentTree && this.ecplDocumentTree.primeNodes) {
            this.applyTranslationsToPrimeNodes(
              this.ecplDocumentTree.primeNodes
            );
            try {
              this.ecplDocumentTree.cdr.detectChanges();
            } catch (e) {}
          }
          if (this.treeActiveNode && this.treeActiveNode.data) {
            let flattenned = this.flattenArrObj(this.treeNode);
            const parent = _.filter(flattenned, [
              'nodeId',
              this.treeActiveNode.data.nodeId
            ]);
            if (parent && parent.length > 0) {
              this.uploadedFiles = parent[0].nodes;
              this.upConfig.title = parent[0].filename;
              if (this.upConfig.addtionalData) {
                this.upConfig.addtionalData.ArchiveFolderId = parent[0].nodeId;
              }
            }
          }
        },
        (error: any) => {
          console.error('Api Error while refreshing tree:', error);
          this.isUpdatingTree = false;
        },
        () => {
          console.log('Refreshing tree service complete.');
          this.isUpdatingTree = false;
        }
      )
    );
  }

  /**
   * Merge new tree data into existing prime nodes without rebuilding
   * Trust server data for structure and content, preserve only UI state (expanded)
   *
   * Strategy: Build a flat map of ALL existing nodes by ID to capture expansion state.
   * Then rebuild the tree from server data, restoring expansion state by ID lookup.
   * This ensures correct names and structure while preserving UI state.
   */
  private mergeTreeData(primeNodes: any[], sourceData: any[]): void {
    if (!primeNodes || !sourceData) return;

    // Step 1: Capture expansion state from ALL existing nodes (flat map by stable key;
    // `id` is a per-response counter that shifts after a move)
    const expansionState = new Map<string, boolean>();
    const captureExpansion = (nodes: any[]) => {
      if (!nodes) return;
      nodes.forEach(node => {
        if (node?.data) {
          expansionState.set(treeNodeKey(node.data), !!node.expanded);
        }
        if (node.children && node.children.length > 0) {
          captureExpansion(node.children);
        }
      });
    };
    captureExpansion(primeNodes);

    const filterByStatus = (nodes: any[]): any[] => {
      if (!nodes || !Array.isArray(nodes)) return [];
      return nodes.filter(node => node.status !== 2).map(node => ({
        ...node,
        nodes: node.nodes ? filterByStatus(node.nodes) : []
      }));
    };

    // Apply status filtering in view mode (not edit mode)
    const dataToRebuild = this.editMode ? sourceData : filterByStatus(sourceData);

    // Step 2: Rebuild tree from server data, restoring expansion state
    const rebuildNodes = (sourceNodesList: any[], depth: number = 0): any[] => {
      if (!sourceNodesList || !Array.isArray(sourceNodesList)) return [];
      
      return sourceNodesList.map(sourceNode => {
        if (!sourceNode) return null;
        
        // Create fresh node from server data
        const node: any = {
          data: { ...sourceNode, _depth: depth, nodes: sourceNode.nodes || [] },
          label: sourceNode.filename,
          expanded: expansionState.get(treeNodeKey(sourceNode)) || false, // Restore expansion state
          selectable: true,
          children: []
        };

        // Recursively build children
        if (Array.isArray(sourceNode.nodes) && sourceNode.nodes.length > 0) {
          node.children = rebuildNodes(sourceNode.nodes, depth + 1);
          node.children.forEach((child: any) => {
            if (child) child.parent = node;
          });
        }

        node.hasChildren = node.children.length > 0;
        node.data.hasChildren = node.hasChildren;
        (node as any).nodes = node.children;

        // Add compatibility methods
        node.setIsSelected = (selected: boolean) => {
          node.selected = !!selected;
          if (node.data) node.data.selected = !!selected;
        };
        node.expand = () => { node.expanded = true; };
        node.collapse = () => { node.expanded = false; };

        return node;
      }).filter(n => n !== null);
    };

    // Step 3: Replace primeNodes content with rebuilt nodes
    const newNodes = rebuildNodes(dataToRebuild, 0);
    primeNodes.splice(0, primeNodes.length, ...newNodes);
  }

  /**
   * Convert source data node to PrimeNG tree node format
   * Similar to tree component's convertNode but without access to component instance
   */
  private convertNodeToChild(data: any, depth: number): any {
    const node: any = {
      data: { ...data, _depth: depth, nodes: data.nodes || [] },
      label: data.filename,
      expanded: !!data.expanded,
      selectable: true,
      children: []
    };
    // Recursively convert children
    if (Array.isArray(data.nodes) && data.nodes.length > 0) {
      node.children = data.nodes.map((c: any) =>
        this.convertNodeToChild(c, depth + 1)
      );
      node.children.forEach((child: any) => {
        child.parent = node;
      });
    }

    node.hasChildren = node.children.length > 0;
    node.data.hasChildren = node.hasChildren;
    (node as any).nodes = node.children;

    // Add compatibility methods
    node.setIsSelected = (selected: boolean) => {
      node.selected = !!selected;
      if (node.data) node.data.selected = !!selected;
    };
    node.expand = () => {
      node.expanded = true;
    };
    node.collapse = () => {
      node.expanded = false;
    };

    return node;
  }

  private configureExplorerForNode(node: any): void {
    if (!node || !node.data) {
      this.uploadedFiles = [];
      this.treeActiveNode = node || null;
      return;
    }

    const nodeData = node.data;
    this.isShowAllFile = true;
    this.uploadedFiles = Array.isArray(nodeData.nodes) ? nodeData.nodes : [];
    this.upConfig.title = nodeData.filename || this.upConfig.title;

    if (nodeData.translateKey === 'CHECKLIST_UNDER_COMPLETION') {
      this.downloadAll = false;
      this.upConfig.showDownloadAll = false;
    } else {
      this.upConfig.showDownloadAll = true;
      this.downloadAll = true;
    }

    this.upConfig.documentType = nodeData.documentType;
    this.upConfig.addtionalData = {
      ApplicationId: BaseServices.ApplicationId,
      BusinessId: BaseServices.BusinessId,
      FolderPath: 'fid-' + this.featureKey + '-' + '',
      FolderTypeName: nodeData.documentType,
      FeatureId: this.featureId,
      FeatureKey: +this.featureKey,
      FeatureName: this.featureName,
      ArchiveFolderId: nodeData.nodeId,
      userId: BaseServices.UserId
    };
    this.treeActiveNode = node;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.bsConfig);
  }

  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.treeNode = this.route.snapshot.data['treeData'];

    // Apply business name transformation
    this.applyBusinessNameToTree(this.treeNode);

    if (this.Userrights == 'User') {
      this.archiveUserRights = BaseServices.userSettings.userFeature.UserRights;
      this.administrateUserRights = JSON.parse(this.archiveUserRights);
      this.administrateUserRights.forEach((element: any) => {
        if (
          element.name == 'ADMINISTRATE_ARCHIVE' &&
          element.isChecked == true
        ) {
          this.isShowButton = true;
        }
      });
    } else {
      this.isShowButton = true;
    }
  }

  /**
   * Apply business name to tree nodes that have "Name of business" as originalFileName.
   * This ensures the actual business name is displayed instead of the placeholder.
   */
  private applyBusinessNameToTree(nodes: any[]): void {
    if (!nodes || !Array.isArray(nodes) || nodes.length === 0) return;
    
    // Check root level nodes
    if (nodes[0] && nodes[0].nodes && Array.isArray(nodes[0].nodes)) {
      nodes[0].nodes.forEach(x => {
        if (x.originalFileName == 'Name of business') {
          x.originalFileName = BaseServices.BusinessName;
          x.filename = BaseServices.BusinessName;
          x.translateKey = null;
          if (BaseServices.BusinessName == null) {
            let BusinessDetails = JSON.parse(
              localStorage.getItem('BusinessDetails')
            );
            x.originalFileName = BusinessDetails.CompanyName;
            x.translateKey = null;
            x.filename = BusinessDetails.CompanyName;
          }
        }
      });
    }
  }

  /**
   * Recursively apply translations to tree nodes when a translate key exists.
   */
  private applyTranslationsToTree(nodes: any[]): void {
    if (!nodes || !Array.isArray(nodes)) return;
    nodes.forEach(node => {
      try {
        if (node && node.translateKey) {
          const translated = this.getTranslatedLabel(node.translateKey);
          if (translated) {
            node.filename = translated;
          }
        }
        if (node.nodes && Array.isArray(node.nodes) && node.nodes.length > 0) {
          this.applyTranslationsToTree(node.nodes);
        }
      } catch (e) {
        console.error('Translation apply error for node', node, e);
      }
    });
  }

  /**
   * Apply translations to PrimeNG node objects (primeNodes) so their `.label` and `.data.filename` reflect the current language. This
   * updates the in-memory nodes so the rendered HTML will show translated names without rebuilding the whole tree.
   */
  private applyTranslationsToPrimeNodes(primeNodes: any[]): void {
    if (!primeNodes || !Array.isArray(primeNodes)) return;
    primeNodes.forEach(pNode => {
      try {
        if (pNode && pNode.data && pNode.data.translateKey) {
          const translated = this.getTranslatedLabel(pNode.data.translateKey);
          if (translated) {
            pNode.data.filename = translated;
            pNode.label = translated;
          }
        }
        // Recurse into PrimeNG children
        if (
          pNode.children &&
          Array.isArray(pNode.children) &&
          pNode.children.length > 0
        ) {
          this.applyTranslationsToPrimeNodes(pNode.children);
        }
      } catch (e) {
        console.error('Translation apply error for prime node', pNode, e);
      }
    });
  }

  /**
   * Resolve a translation for a folder key.
   */
  private getTranslatedLabel(key: string): string | undefined {
    if (!key) return undefined;
    try {
      const direct = this.translate.instant(key);
      if (direct && direct !== key) return direct;
      const df = this.translate.instant('DEFAULT_FOLDER');
      if (df && typeof df === 'object' && df[key]) return df[key];
      const dotted = this.translate.instant(`DEFAULT_FOLDER.${key}`);
      if (dotted && dotted !== `DEFAULT_FOLDER.${key}`) return dotted;
    } catch (e) {}
    return undefined;
  }

  // private
  private flattenArrObj(arr: any) {
    let newArr: any = [];
    if (Array.isArray(arr) && arr.length > 0) {
      arr.forEach(element => {
        newArr.push(element);
        if (Array.isArray(element.nodes) && element.nodes.length > 0) {
          newArr = newArr.concat(this.flattenArrObj(element.nodes));
        }
      });
    }
    return newArr;
  }

  /**
   * Method to extract node ids from the tree data
   * @param nodes - Array of TreeData objects
   * @returns Array of node ids
   */
  private extractNodeIds(nodes: TreeData[]): number[] {
    const nodeIds: number[] = [];
    nodes.forEach(node => {
      nodeIds.push(node.nodeId);
    });

    return nodeIds;
  }

  showAllFiles() {
    this.isShowAllFile = false;
    this.allFiles = this.flattenArrObj(this.treeNode);

    this.uploadedFiles = this.allFiles;
  }
}
